import { DateTime } from "luxon";
import { useCallback, useEffect, useMemo, useState } from "react";
import seedrandom from "seedrandom";
import {
  townsWithImage,
  Town,
} from "../domain/towns";
import { Guess, loadAllGuesses, saveGuesses } from "../domain/guess";

const forcedTowns: Record<string, string> = {
  "2024-01-23": "46128",
  "2024-01-24": "46235",
  "2024-01-25": "12027",
  "2024-01-26": "03064",
  "2024-01-27": "12138",
  "2024-01-28": "03065",
  "2024-01-29": "03031",
  "2024-01-30": "12013",
  "2024-01-31": "46193",
  "2024-02-01": "46198",
  "2024-02-02": "03133",
  "2024-02-03": "46072",
  "2024-02-04": "46071",
  "2024-02-05": "46181",
  "2024-02-06": "46010",
  "2024-02-07": "46131",
  "2024-02-08": "46258",
  "2024-02-09": "46047",
  "2024-02-10": "46036",
  "2024-02-11": "46029",
  "2024-02-12": "12080",
  "2024-02-13": "46080",
  "2024-02-14": "46094",
  "2024-02-15": "03075",
  "2024-02-16": "03049",
  "2024-02-17": "03066",
  "2024-02-18": "46147",
  "2024-02-19": "12045",
  "2024-02-20": "46098",
  "2024-02-21": "03089",
  "2024-02-22": "12901",
  "2024-02-23": "46102",
  "2024-02-24": "46184",
  "2024-02-25": "46205",
  "2024-02-26": "46087",
  "2024-02-27": "46013",
  "2024-02-28": "46183",
  "2024-02-29": "12038",
  "2024-03-01": "03105",
  "2024-03-02": "12040",
  "2024-03-03": "46244",
  "2024-03-04": "03139",
  "2024-03-05": "12020",
  "2024-03-06": "12037",
  "2024-03-07": "46077",
  "2024-03-08": "46188",
  "2024-03-09": "12003",
  "2024-03-10": "46145",
  "2024-03-11": "46213",
  "2024-03-12": "46189",
  "2024-03-13": "03063",
  "2024-03-14": "46118",
  "2024-03-15": "03018",
  "2024-03-16": "12103",
  "2024-03-17": "46190",
  "2024-03-18": "12032",
  "2024-03-19": "46250",
  "2024-03-20": "03071",
  "2024-03-21": "03039",
  "2024-03-22": "46017",
  "2024-03-23": "12005",
  "2024-03-24": "46011",
  "2024-03-25": "03099",
  "2024-03-26": "12122",
  "2024-03-27": "46220",
  "2024-03-28": "12117",
  "2024-03-29": "46159",
  "2024-03-30": "46129",
  "2024-03-31": "12075",
  "2024-04-01": "12084",
  "2024-04-02": "12069",
  "2024-04-03": "46165",
  "2024-04-04": "12089",
  "2024-04-05": "03082",
  "2024-04-06": "12140",
  "2024-04-07": "03902",
  "2024-04-08": "46249",
  "2024-04-09": "46132",
  "2024-04-10": "12068",
  "2024-04-11": "03014",
  "2024-04-12": "46245",
  "2024-04-13": "03011",
  "2024-04-14": "03079",
  "2024-04-15": "46117",
  "2024-04-16": "03083",
  "2024-04-17": "12006",
  "2024-04-18": "46223",
  "2024-04-19": "03127",
  "2024-04-20": "03009",
  "2024-04-21": "12087",
  "2024-04-22": "03019",
  "2024-04-23": "12099",
  "2024-04-24": "46105",
  "2024-04-25": "46079",
  "2024-04-26": "46224",
  "2024-04-27": "12135",
  "2024-04-28": "46227",
  "2024-04-29": "46195",
  "2024-04-30": "46257",
  "2024-05-01": "03056",
  "2024-05-02": "03048",
  "2024-05-03": "46004",
  "2024-05-04": "46035",
  "2024-05-05": "46041",
  "2024-05-06": "03092",
  "2024-05-07": "46256",
  "2024-05-08": "03043",
  "2024-05-09": "46254",
  "2024-05-10": "03121",
  "2024-05-11": "46143",
  "2024-05-12": "12058",
  "2024-05-13": "46204",
  "2024-05-14": "12079",
  "2024-05-15": "03901",
  "2024-05-16": "03140",
  "2024-05-17": "03006",
  "2024-05-18": "46021",
  "2024-05-19": "03047",
  "2024-05-20": "12046",
  "2024-05-21": "46008",
  "2024-05-22": "12104",
  "2024-05-23": "12009",
  "2024-05-24": "12071",
  "2024-05-25": "03119",
  "2024-05-26": "46126",
  "2024-05-27": "46006",
  "2024-05-28": "12082",
  "2024-05-29": "46196",
  "2024-05-30": "12127",
  "2024-05-31": "03103",
  "2024-06-01": "46187",
  "2024-06-02": "03122",
  "2024-06-03": "12110",
  "2024-06-04": "46239",
  "2024-06-05": "46001",
  "2024-06-06": "46005",
  "2024-06-07": "03059",
  "2024-06-08": "03002",
  "2024-06-09": "03050",
  "2024-06-10": "12126",
  "2024-06-11": "46078",
  "2024-06-12": "03104",
  "2024-06-13": "46042",
  "2024-06-14": "12034",
  "2024-06-15": "46106",
  "2024-06-16": "46044",
  "2024-06-17": "46111",
  "2024-06-18": "12050",
  "2024-06-19": "03120",
  "2024-06-20": "12021",
  "2024-06-21": "12011",
  "2024-06-22": "12115",
  "2024-06-23": "46166",
  "2024-06-24": "03137",
  "2024-06-25": "03085",
  "2024-06-26": "46152",
  "2024-06-27": "12100",
  "2024-06-28": "46137",
  "2024-06-29": "03004",
  "2024-06-30": "12109",
  "2024-07-01": "12029",
  "2024-07-02": "12117",
  "2024-07-03": "03083",
  "2024-07-04": "12124",
  "2024-07-05": "46148",
  "2024-07-06": "46053",
  "2024-07-07": "03124",
  "2024-07-08": "03063",
  "2024-07-09": "46052",
  "2024-07-10": "46175",
  "2024-07-11": "12142",
  "2024-07-12": "03086",
  "2024-07-13": "03005",
  "2024-07-14": "03129",
  "2024-07-15": "46185",
  "2024-07-16": "03012",
  "2024-07-17": "46241",
  "2024-07-18": "46192",
  "2024-07-19": "03084",
  "2024-07-20": "03113",
  "2024-07-21": "03133",
  "2024-07-22": "03095",
  "2024-07-23": "03093",
  "2024-07-24": "12016",
  "2024-07-25": "03139",
  "2024-07-26": "12141",
  "2024-07-27": "46040",
  "2024-07-28": "12026",
  "2024-07-29": "46244",
  "2024-07-30": "03013",
  "2024-07-31": "12098",
  "2024-08-01": "46142",
  "2024-08-02": "12063",
  "2024-08-03": "46206",
  "2024-08-04": "03081",
  "2024-08-05": "03027",
  "2024-08-06": "46021",
  "2024-08-07": "46185",
  "2024-08-08": "46042",
  "2024-08-09": "12125",
  "2024-08-10": "03018",
  "2024-08-11": "46161",
  "2024-08-12": "12010",
  "2024-08-13": "46254",
  "2024-08-14": "46128",
  "2024-08-15": "46235",
  "2024-08-16": "12027",
  "2024-08-17": "03064",
  "2024-08-18": "12138",
  "2024-08-19": "03065",
  "2024-08-20": "03031",
  "2024-08-21": "12013",
  "2024-08-22": "46193",
  "2024-08-23": "46198",
  "2024-08-24": "03133",
  "2024-08-25": "46072",
  "2024-08-26": "46071",
  "2024-08-27": "46181",
  "2024-08-28": "46010",
  "2024-08-29": "46131",
  "2024-08-30": "46258",
  "2024-08-31": "46047",
  "2024-09-01": "46036",
  "2024-09-02": "46029",
  "2024-09-03": "12080",
  "2024-09-04": "46080",
  "2024-09-05": "46094",
  "2024-09-06": "03075",
  "2024-09-07": "03049",
  "2024-09-08": "03066",
  "2024-09-09": "46147",
  "2024-09-10": "12045",
  "2024-09-11": "46098",
  "2024-09-12": "03089",
  "2024-09-13": "12901",
  "2024-09-14": "46102",
  "2024-09-15": "46184",
  "2024-09-16": "46205",
  "2024-09-17": "46087",
  "2024-09-18": "46013",
  "2024-09-19": "46183",
  "2024-09-20": "12038",
  "2024-09-21": "03105",
  "2024-09-22": "12040",
  "2024-09-23": "46244",
  "2024-09-24": "03139",
  "2024-09-25": "12020",
  "2024-09-26": "12037",
  "2024-09-27": "46077",
  "2024-09-28": "46188",
  "2024-09-29": "12003",
  "2024-09-30": "46145",
  "2024-10-01": "46213",
  "2024-10-02": "46189",
  "2024-10-03": "03063",
  "2024-10-04": "46118",
  "2024-10-05": "03018",
  "2024-10-06": "12103",
  "2024-10-07": "46190",
  "2024-10-08": "12032",
  "2024-10-09": "46250",
  "2024-10-10": "03071",
  "2024-10-11": "03039",
  "2024-10-12": "46017",
  "2024-10-13": "12005",
  "2024-10-14": "46011",
  "2024-10-15": "03099",
  "2024-10-16": "12122",
  "2024-10-17": "46220",
  "2024-10-18": "12117",
  "2024-10-19": "46159",
  "2024-10-20": "46129",
  "2024-10-21": "12075",
  "2024-10-22": "12084",
  "2024-10-23": "12069",
  "2024-10-24": "46165",
  "2024-10-25": "12089",
  "2024-10-26": "03082",
  "2024-10-27": "12140",
  "2024-10-28": "03902",
  "2024-10-29": "46249",
  "2024-10-30": "46132",
  "2024-10-31": "12068",
  "2024-11-01": "03014",
  "2024-11-02": "46245",
  "2024-11-03": "03011",
  "2024-11-04": "03079",
  "2024-11-05": "46117",
  "2024-11-06": "03083",
  "2024-11-07": "12006",
  "2024-11-08": "46223",
  "2024-11-09": "03127",
  "2024-11-10": "03009",
  "2024-11-11": "12087",
  "2024-11-12": "03019",
  "2024-11-13": "12099",
  "2024-11-14": "46105",
  "2024-11-15": "46079",
  "2024-11-16": "46224",
  "2024-11-17": "12135",
  "2024-11-18": "46227",
  "2024-11-19": "46195",
  "2024-11-20": "46257",
  "2024-11-21": "03056",
  "2024-11-22": "03048",
  "2024-11-23": "46004",
  "2024-11-24": "46035",
  "2024-11-25": "46041",
  "2024-11-26": "03092",
  "2024-11-27": "46256",
  "2024-11-28": "03043",
  "2024-11-29": "46254",
  "2024-11-30": "03121",
  "2024-12-01": "46143",
  "2024-12-02": "12058",
  "2024-12-03": "46204",
  "2024-12-04": "12079",
  "2024-12-05": "03901",
  "2024-12-06": "03140",
  "2024-12-07": "03006",
  "2024-12-08": "46021",
  "2024-12-09": "03047",
  "2024-12-10": "12046",
  "2024-12-11": "46008",
  "2024-12-12": "46017",
  "2024-12-13": "12009",
  "2024-12-14": "12071",
  "2024-12-15": "03119",
  "2024-12-16": "46126",
  "2024-12-17": "46006",
  "2024-12-18": "12082",
  "2024-12-19": "46196",
  "2024-12-20": "12127",
  "2024-12-21": "03103",
  "2024-12-22": "46187",
  "2024-12-23": "03122",
  "2024-12-24": "12110",
  "2024-12-25": "46239",
  "2024-12-26": "46001",
  "2024-12-27": "46005",
  "2024-12-28": "03059",
  "2024-12-29": "03002",
  "2024-12-30": "03050",
  "2024-12-31": "46128",
  "2025-01-01": "46235",
  "2025-01-02": "12027",
  "2025-01-03": "03064",
  "2025-01-04": "12138",
  "2025-01-05": "03065",
  "2025-01-06": "03031",
  "2025-01-07": "12013",
  "2025-01-08": "46193",
  "2025-01-09": "46198",
  "2025-01-10": "03133",
  "2025-01-11": "46072",
  "2025-01-12": "46071",
  "2025-01-13": "46181",
  "2025-01-14": "46010",
  "2025-01-15": "46131",
  "2025-01-16": "46258",
  "2025-01-17": "46047",
  "2025-01-18": "46036",
  "2025-01-19": "46029",
  "2025-01-20": "12080",
  "2025-01-21": "46080",
  "2025-01-22": "46094",
  "2025-01-23": "03075",
  "2025-01-24": "03049",
  "2025-01-25": "03066",
  "2025-01-26": "46147",
  "2025-01-27": "12045",
  "2025-01-28": "46098",
  "2025-01-29": "03089",
  "2025-01-30": "12901",
  "2025-01-31": "46102",
  "2025-02-01": "46184",
  "2025-02-02": "46205",
  "2025-02-03": "46087",
  "2025-02-04": "46013",
  "2025-02-05": "46183",
  "2025-02-06": "12038",
  "2025-02-07": "03105",
  "2025-02-08": "12040",
  "2025-02-09": "46244",
  "2025-02-10": "03139",
  "2025-02-11": "12020",
  "2025-02-12": "12037",
  "2025-02-13": "46077",
  "2025-02-14": "46188",
  "2025-02-15": "12003",
  "2025-02-16": "46145",
  "2025-02-17": "46213",
  "2025-02-18": "46189",
  "2025-02-19": "03063",
  "2025-02-20": "46118",
  "2025-02-21": "03018",
  "2025-02-22": "12103",
  "2025-02-23": "46190",
  "2025-02-24": "12032",
  "2025-02-25": "46250",
  "2025-02-26": "03071",
  "2025-02-27": "03039",
  "2025-02-28": "12104",
  "2025-03-01": "12005",
  "2025-03-02": "46011",
  "2025-03-03": "03099",
  "2025-03-04": "12122",
  "2025-03-05": "46220",
  "2025-03-06": "12117",
  "2025-03-07": "46159",
  "2025-03-08": "46129",
  "2025-03-09": "12075",
  "2025-03-10": "12084",
  "2025-03-11": "12069",
  "2025-03-12": "46165",
  "2025-03-13": "12089",
  "2025-03-14": "03082",
  "2025-03-15": "12140",
  "2025-03-16": "03902",
  "2025-03-17": "46249",
  "2025-03-18": "46132",
  "2025-03-19": "12068",
  "2025-03-20": "03014",
  "2025-03-21": "46245",
  "2025-03-22": "03011",
  "2025-03-23": "03079",
  "2025-03-24": "46117",
  "2025-03-25": "03083",
  "2025-03-26": "12006",
  "2025-03-27": "46223",
  "2025-03-28": "03127",
  "2025-03-29": "03009",
  "2025-03-30": "12087",
  "2025-03-31": "03019",
  "2025-04-01": "12099",
  "2025-04-02": "46105",
  "2025-04-03": "46079",
  "2025-04-04": "46224",
  "2025-04-05": "12135",
  "2025-04-06": "46227",
  "2025-04-07": "46195",
  "2025-04-08": "46257",
  "2025-04-09": "03056",
  "2025-04-10": "03048",
  "2025-04-11": "46004",
  "2025-04-12": "46035",
  "2025-04-13": "46041",
  "2025-04-14": "03092",
  "2025-04-15": "46256",
  "2025-04-16": "03043",
  "2025-04-17": "46254",
  "2025-04-18": "03121",
  "2025-04-19": "46143",
  "2025-04-20": "12058",
  "2025-04-21": "46204",
  "2025-04-22": "12079",
  "2025-04-23": "03901",
  "2025-04-24": "03140",
  "2025-04-25": "03006",
  "2025-04-26": "46021",
  "2025-04-27": "03047",
  "2025-04-28": "12046",
  "2025-04-29": "46008",
  "2025-04-30": "46017",
  "2025-05-01": "12009",
  "2025-05-02": "12071",
  "2025-05-03": "03119",
  "2025-05-04": "46126",
  "2025-05-05": "46006",
  "2025-05-06": "12082",
  "2025-05-07": "46196",
  "2025-05-08": "12127",
  "2025-05-09": "03103",
  "2025-05-10": "46187",
  "2025-05-11": "03122",
  "2025-05-12": "12110",
  "2025-05-13": "46239",
  "2025-05-14": "46001",
  "2025-05-15": "46005",
  "2025-05-16": "03059",
  "2025-05-17": "03002",
  "2025-05-18": "03050",
  "2025-05-19": "12126",
  "2025-05-20": "46078",
  "2025-05-21": "03104",
  "2025-05-22": "46042",
  "2025-05-23": "12034",
  "2025-05-24": "46106",
  "2025-05-25": "46044",
  "2025-05-26": "46111",
  "2025-05-27": "12050",
  "2025-05-28": "03120",
  "2025-05-29": "12021",
  "2025-05-30": "12011",
  "2025-05-31": "12115",
  "2025-06-01": "46166",
  "2025-06-02": "03137",
  "2025-06-03": "03085",
  "2025-06-04": "46152",
  "2025-06-05": "12100",
  "2025-06-06": "46137",
  "2025-06-07": "03004",
  "2025-06-08": "12109",
  "2025-06-09": "12029",
  "2025-06-10": "12117",
  "2025-06-11": "03083",
  "2025-06-12": "12124",
  "2025-06-13": "46148",
  "2025-06-14": "46053",
  "2025-06-15": "03124",
  "2025-06-16": "03063",
  "2025-06-17": "46052",
  "2025-06-18": "46175",
  "2025-06-19": "12142",
  "2025-06-20": "03086",
  "2025-06-21": "03005",
  "2025-06-22": "03129",
  "2025-06-23": "46185",
  "2025-06-24": "03012",
  "2025-06-25": "46241",
  "2025-06-26": "46192",
  "2025-06-27": "03084",
  "2025-06-28": "03113",
  "2025-06-29": "03133",
  "2025-06-30": "03095",
  "2025-07-01": "03093",
  "2025-07-02": "12016",
  "2025-07-03": "03139",
  "2025-07-04": "12141",
  "2025-07-05": "46040",
  "2025-07-06": "12026",
  "2025-07-07": "46244",
  "2025-07-08": "03013",
  "2025-07-09": "12098",
  "2025-07-10": "46142",
  "2025-07-11": "12063",
  "2025-07-12": "46206",
  "2025-07-13": "03081",
  "2025-07-14": "03027",
  "2025-07-15": "46021",
  "2025-07-16": "46185",
  "2025-07-17": "46042",
  "2025-07-18": "12125",
  "2025-07-19": "03018",
  "2025-07-20": "46161",
  "2025-07-21": "12010",
  "2025-07-22": "46254",
  "2025-07-23": "46128",
  "2025-07-24": "46235",
  "2025-07-25": "12027",
  "2025-07-26": "03064",
  "2025-07-27": "12138",
  "2025-07-28": "03065",
  "2025-07-29": "03031",
  "2025-07-30": "12013",
  "2025-07-31": "46193",
  "2025-08-01": "46198",
  "2025-08-02": "03133",
  "2025-08-03": "46072",
  "2025-08-04": "46071",
  "2025-08-05": "46181",
  "2025-08-06": "46010",
  "2025-08-07": "46131",
  "2025-08-08": "46258",
  "2025-08-09": "46047",
  "2025-08-10": "46036",
  "2025-08-11": "46029",
  "2025-08-12": "12080",
  "2025-08-13": "46080",
  "2025-08-14": "46094",
  "2025-08-15": "03075",
  "2025-08-16": "03049",
  "2025-08-17": "03066",
  "2025-08-18": "46147",
  "2025-08-19": "12045",
  "2025-08-20": "46098",
  "2025-08-21": "03089",
  "2025-08-22": "12901",
  "2025-08-23": "46102",
  "2025-08-24": "46184",
  "2025-08-25": "46205",
  "2025-08-26": "46087",
  "2025-08-27": "46013",
  "2025-08-28": "46183",
  "2025-08-29": "12038",
  "2025-08-30": "03105",
  "2025-08-31": "12040",
  "2025-09-01": "46244",
  "2025-09-02": "03139",
  "2025-09-03": "12020",
  "2025-09-04": "12037",
  "2025-09-05": "46077",
  "2025-09-06": "46188",
  "2025-09-07": "12003",
  "2025-09-08": "46145",
  "2025-09-09": "46213",
  "2025-09-10": "46189",
  "2025-09-11": "03063",
  "2025-09-12": "46118",
  "2025-09-13": "03018",
  "2025-09-14": "12103",
  "2025-09-15": "46190",
  "2025-09-16": "12032",
  "2025-09-17": "46250",
  "2025-09-18": "03071",
  "2025-09-19": "03039",
  "2025-09-20": "46017",
  "2025-09-21": "12005",
  "2025-09-22": "46011",
  "2025-09-23": "03099",
  "2025-09-24": "12122",
  "2025-09-25": "46220",
  "2025-09-26": "12117",
  "2025-09-27": "46159",
  "2025-09-28": "46129",
  "2025-09-29": "12075",
  "2025-09-30": "12084",
  "2025-10-01": "12069",
  "2025-10-02": "46165",
  "2025-10-03": "12089",
  "2025-10-04": "03082",
  "2025-10-05": "12140",
  "2025-10-06": "03902",
  "2025-10-07": "46249",
  "2025-10-08": "46132",
  "2025-10-09": "12068",
  "2025-10-10": "03014",
  "2025-10-11": "46245",
  "2025-10-12": "03011",
  "2025-10-13": "03079",
  "2025-10-14": "46117",
  "2025-10-15": "03083",
  "2025-10-16": "12006",
  "2025-10-17": "46223",
  "2025-10-18": "03127",
  "2025-10-19": "03009",
  "2025-10-20": "12087",
  "2025-10-21": "03019",
  "2025-10-22": "12099",
  "2025-10-23": "46105",
  "2025-10-24": "46079",
  "2025-10-25": "46224",
  "2025-10-26": "12135",
  "2025-10-27": "46227",
  "2025-10-28": "46195",
  "2025-10-29": "46257",
  "2025-10-30": "03056",
  "2025-10-31": "03048",
  "2025-11-01": "46004",
  "2025-11-02": "46035",
  "2025-11-03": "46041",
  "2025-11-04": "03092",
  "2025-11-05": "46256",
  "2025-11-06": "03043",
  "2025-11-07": "46254",
  "2025-11-08": "03121",
  "2025-11-09": "46143",
  "2025-11-10": "12058",
  "2025-11-11": "46204",
  "2025-11-12": "12079",
  "2025-11-13": "03901",
  "2025-11-14": "03140",
  "2025-11-15": "03006",
  "2025-11-16": "46021",
  "2025-11-17": "03047",
  "2025-11-18": "12046",
  "2025-11-19": "46008",
  "2025-11-20": "12104",
  "2025-11-21": "12009",
  "2025-11-22": "12071",
  "2025-11-23": "03119",
  "2025-11-24": "46126",
  "2025-11-25": "46006",
  "2025-11-26": "12082",
  "2025-11-27": "46196",
  "2025-11-28": "12127",
  "2025-11-29": "03103",
  "2025-11-30": "46187",
  "2025-12-01": "03122",
  "2025-12-02": "12110",
  "2025-12-03": "46239",
  "2025-12-04": "46001",
  "2025-12-05": "46005",
  "2025-12-06": "03059",
  "2025-12-07": "03002",
  "2025-12-08": "03050",
  "2025-12-09": "12126",
  "2025-12-10": "46078",
  "2025-12-11": "03104",
  "2025-12-12": "12034",
  "2025-12-13": "46106",
  "2025-12-14": "46044",
  "2025-12-15": "46111",
  "2025-12-16": "12050",
  "2025-12-17": "03120",
  "2025-12-18": "12021",
  "2025-12-19": "12011",
  "2025-12-20": "12115",
  "2025-12-21": "46166",
  "2025-12-22": "03137",
  "2025-12-23": "03085",
  "2025-12-24": "46152",
  "2025-12-25": "12100",
  "2025-12-26": "46137",
  "2025-12-27": "03004",
  "2025-12-28": "12109",
  "2025-12-29": "12029",
  "2025-12-30": "12124",
  "2025-12-31": "46148",
  "2026-01-01": "46053",
  "2026-01-02": "03124",
  "2026-01-03": "46052",
  "2026-01-04": "46175",
  "2026-01-05": "12142",
  "2026-01-06": "03086",
  "2026-01-07": "03005",
  "2026-01-08": "03129",
  "2026-01-09": "03012",
  "2026-01-10": "46241",
  "2026-01-11": "46192",
  "2026-01-12": "03084",
  "2026-01-13": "03113",
  "2026-01-14": "03013",
  "2026-01-15": "12098",
  "2026-01-16": "46142",
  "2026-01-17": "12063",
  "2026-01-18": "46206",
  "2026-01-19": "03081",
  "2026-01-20": "03027",
  "2026-01-21": "12141",
  "2026-01-22": "46040",
  "2026-01-23": "12026",
  "2026-01-24": "12125",
  "2026-01-25": "46161",
  "2026-01-26": "12010",
  "2026-01-27": "46128",
  "2026-01-28": "46235",
  "2026-01-29": "12027",
  "2026-01-30": "03064",
  "2026-01-31": "12138",
  "2026-02-01": "03065",
  "2026-02-02": "03031",
  "2026-02-03": "12013",
  "2026-02-04": "46193",
  "2026-02-05": "46198",
  "2026-02-06": "03095",
  "2026-02-07": "46072",
  "2026-02-08": "46071",
  "2026-02-09": "46181",
  "2026-02-10": "46010",
  "2026-02-11": "46131",
  "2026-02-12": "46258",
  "2026-02-13": "46047",
  "2026-02-14": "46036",
  "2026-02-15": "46029",
  "2026-02-16": "12080",
  "2026-02-17": "46080",
  "2026-02-18": "46094",
  "2026-02-19": "03075",
  "2026-02-20": "03049",
  "2026-02-21": "03066",
  "2026-02-22": "46147",
  "2026-02-23": "12045",
  "2026-02-24": "46098",
  "2026-02-25": "03089",
  "2026-02-26": "12901",
  "2026-02-27": "46102",
  "2026-02-28": "46184",
  "2026-03-01": "46205",
  "2026-03-02": "46087",
  "2026-03-03": "46013",
  "2026-03-04": "46183",
  "2026-03-05": "12038",
  "2026-03-06": "03105",
  "2026-03-07": "12040",
  "2026-03-08": "03902",
  "2026-03-09": "46249",
  "2026-03-10": "12020",
  "2026-03-11": "12037",
  "2026-03-12": "46077",
  "2026-03-13": "46188",
  "2026-03-14": "12003",
  "2026-03-15": "46145",
  "2026-03-16": "46213",
  "2026-03-17": "46189",
  "2026-03-18": "03124",
  "2026-03-19": "46118",
  "2026-03-20": "03104",
  "2026-03-21": "12103",
  "2026-03-22": "46190",
  "2026-03-23": "12032",
  "2026-03-24": "46250",
  "2026-03-25": "03071",
  "2026-03-26": "03039",
  "2026-03-27": "46017",
  "2026-03-28": "12005",
  "2026-03-29": "46011",
  "2026-03-30": "03099",
  "2026-03-31": "12122",
  "2026-04-01": "46220",
  "2026-04-02": "46042",
  "2026-04-03": "46159",
  "2026-04-04": "46129",
  "2026-04-05": "12075",
  "2026-04-06": "12084",
  "2026-04-07": "12069",
  "2026-04-08": "46165",
  "2026-04-09": "12089",
  "2026-04-10": "03082",
  "2026-04-11": "12140",
  "2026-04-12": "03902",
  "2026-04-13": "46249",
  "2026-04-14": "46132",
  "2026-04-15": "12068",
  "2026-04-16": "03014",
  "2026-04-17": "46245",
  "2026-04-18": "03011",
  "2026-04-19": "03079",
  "2026-04-20": "46117",
  "2026-04-21": "03083",
  "2026-04-22": "12006",
  "2026-04-23": "46223",
  "2026-04-24": "03127",
  "2026-04-25": "03009",
  "2026-04-26": "12087",
  "2026-04-27": "03019",
  "2026-04-28": "12099",
  "2026-04-29": "46105",
  "2026-04-30": "46079",
  "2026-05-01": "46224",
  "2026-05-02": "12135",
  "2026-05-03": "46227",
  "2026-05-04": "46195",
  "2026-05-05": "46257",
  "2026-05-06": "03056",
  "2026-05-07": "03048",
  "2026-05-08": "46004",
  "2026-05-09": "46035",
  "2026-05-10": "46041",
  "2026-05-11": "03092",
  "2026-05-12": "46256",
  "2026-05-13": "03043",
  "2026-05-14": "03093",
  "2026-05-15": "03121",
  "2026-05-16": "46143",
  "2026-05-17": "12058",
  "2026-05-18": "46204",
  "2026-05-19": "12079",
  "2026-05-20": "03901",
  "2026-05-21": "03140",
  "2026-05-22": "03006",
  "2026-05-23": "12016",
  "2026-05-24": "03047",
  "2026-05-25": "12046",
  "2026-05-26": "46008",
  "2026-05-27": "12104",
  "2026-05-28": "12009",
  "2026-05-29": "12071",
  "2026-05-30": "03119",
  "2026-05-31": "46126",
  "2026-06-01": "46006",
  "2026-06-02": "12082",
  "2026-06-03": "46196",
  "2026-06-04": "12127",
  "2026-06-05": "03103",
  "2026-06-06": "46187",
  "2026-06-07": "03122",
  "2026-06-08": "12110",
  "2026-06-09": "46239",
  "2026-06-10": "46001",
  "2026-06-11": "46005",
  "2026-06-12": "03059",
  "2026-06-13": "03002",
  "2026-06-14": "03050",
  "2026-06-15": "12126",
  "2026-06-16": "46078",
  "2026-06-17": "12034",
  "2026-06-18": "46106",
  "2026-06-19": "46044",
  "2026-06-20": "46111",
  "2026-06-21": "12050",
  "2026-06-22": "03120",
  "2026-06-23": "12021",
  "2026-06-24": "12011",
  "2026-06-25": "12115",
  "2026-06-26": "46166",
  "2026-06-27": "03137",
  "2026-06-28": "03085",
  "2026-06-29": "46152",
  "2026-06-30": "12100",
  "2026-07-01": "46137",
  "2026-07-02": "03004",
  "2026-07-03": "12109",
  "2026-07-04": "12029",
  "2026-07-05": "12124",
  "2026-07-06": "46148",
  "2026-07-07": "46053",
  "2026-07-08": "03124",
  "2026-07-09": "46052",
  "2026-07-10": "46175",
  "2026-07-11": "12142",
  "2026-07-12": "03086",
  "2026-07-13": "03005",
  "2026-07-14": "03129",
  "2026-07-15": "03012",
  "2026-07-16": "46241",
  "2026-07-17": "46192",
  "2026-07-18": "03084",
  "2026-07-19": "03113",
  "2026-07-20": "03013",
  "2026-07-21": "12098",
  "2026-07-22": "46142",
  "2026-07-23": "12063",
  "2026-07-24": "46206",
  "2026-07-25": "03081",
  "2026-07-26": "03027",
  "2026-07-27": "12141",
  "2026-07-28": "46040",
  "2026-07-29": "12026",
  "2026-07-30": "12125",
  "2026-07-31": "46161",
  "2026-08-01": "12010",
  "2026-08-02": "46128",
  "2026-08-03": "46235",
  "2026-08-04": "12027",
  "2026-08-05": "03064",
  "2026-08-06": "12138",
  "2026-08-07": "03065",
  "2026-08-08": "03031",
  "2026-08-09": "12013",
  "2026-08-10": "46193",
  "2026-08-11": "46198",
  "2026-08-12": "03095",
  "2026-08-13": "46072",
  "2026-08-14": "46071",
  "2026-08-15": "46181",
  "2026-08-16": "46010",
  "2026-08-17": "46131",
  "2026-08-18": "46258",
  "2026-08-19": "46047",
  "2026-08-20": "46036",
  "2026-08-21": "46029",
  "2026-08-22": "12080",
  "2026-08-23": "46080",
  "2026-08-24": "46094",
  "2026-08-25": "03075",
  "2026-08-26": "03049",
  "2026-08-27": "03066",
  "2026-08-28": "46147",
  "2026-08-29": "12045",
  "2026-08-30": "46098",
  "2026-08-31": "03089",
  "2026-09-01": "12901",
  "2026-09-02": "46102",
  "2026-09-03": "46184",
  "2026-09-04": "46205",
  "2026-09-05": "46087",
  "2026-09-06": "46013",
  "2026-09-07": "46183",
  "2026-09-08": "12038",
  "2026-09-09": "03105",
  "2026-09-10": "12040",
  "2026-09-11": "03902",
  "2026-09-12": "46249",
  "2026-09-13": "12020",
  "2026-09-14": "12037",
  "2026-09-15": "46077",
  "2026-09-16": "46188",
  "2026-09-17": "12003",
  "2026-09-18": "46145",
  "2026-09-19": "46213",
  "2026-09-20": "46189",
  "2026-09-21": "46118",
  "2026-09-22": "03104",
  "2026-09-23": "12103",
  "2026-09-24": "46190",
  "2026-09-25": "12032",
  "2026-09-26": "46250",
  "2026-09-27": "03071",
  "2026-09-28": "03039",
  "2026-09-29": "46017",
  "2026-09-30": "12005",
  "2026-10-01": "46011",
  "2026-10-02": "03099",
  "2026-10-03": "12122",
  "2026-10-04": "46220",
  "2026-10-05": "46042",
  "2026-10-06": "46159",
  "2026-10-07": "46129",
  "2026-10-08": "12075",
  "2026-10-09": "12084",
  "2026-10-10": "12069",
  "2026-10-11": "46165",
  "2026-10-12": "12089",
  "2026-10-13": "03082",
  "2026-10-14": "12140",
  "2026-10-15": "03902",
  "2026-10-16": "46249",
  "2026-10-17": "46132",
  "2026-10-18": "12068",
  "2026-10-19": "03014",
  "2026-10-20": "46245",
  "2026-10-21": "03011",
  "2026-10-22": "03079",
  "2026-10-23": "46117",
  "2026-10-24": "03083",
  "2026-10-25": "12006",
  "2026-10-26": "46223",
  "2026-10-27": "03127",
  "2026-10-28": "03009",
  "2026-10-29": "12087",
  "2026-10-30": "03019",
  "2026-10-31": "12099",
  "2026-11-01": "46105",
  "2026-11-02": "46079",
  "2026-11-03": "46224",
  "2026-11-04": "12135",
  "2026-11-05": "46227",
  "2026-11-06": "46195",
  "2026-11-07": "46257",
  "2026-11-08": "03056",
  "2026-11-09": "03048",
  "2026-11-10": "46004",
  "2026-11-11": "46035",
  "2026-11-12": "46041",
  "2026-11-13": "03092",
  "2026-11-14": "46256",
  "2026-11-15": "03043",
  "2026-11-16": "03093",
  "2026-11-17": "03121",
  "2026-11-18": "46143",
  "2026-11-19": "12058",
  "2026-11-20": "46204",
  "2026-11-21": "12079",
  "2026-11-22": "03901",
  "2026-11-23": "03140",
  "2026-11-24": "03006",
  "2026-11-25": "12016",
  "2026-11-26": "03047",
  "2026-11-27": "12046",
  "2026-11-28": "46008",
  "2026-11-29": "12104",
  "2026-11-30": "12009",
  "2026-12-01": "12071",
  "2026-12-02": "03119",
  "2026-12-03": "46126",
  "2026-12-04": "46006",
  "2026-12-05": "12082",
  "2026-12-06": "46196",
  "2026-12-07": "12127",
  "2026-12-08": "03103",
  "2026-12-09": "46187",
  "2026-12-10": "03122",
  "2026-12-11": "12110",
  "2026-12-12": "46239",
  "2026-12-13": "46001",
  "2026-12-14": "46005",
  "2026-12-15": "03059",
  "2026-12-16": "03002",
  "2026-12-17": "03050",
  "2026-12-18": "12126",
  "2026-12-19": "46078"
};

export function getDayString(shiftDayCount?: number) {
  return DateTime.now()
    .plus({ days: shiftDayCount ?? 0 })
    .toFormat("yyyy-MM-dd");
}

export function useTodays(dayString: string): [
  {
    town?: Town;
    guesses: Guess[];
  },
  (guess: Guess) => void,
  number,
  number
] {
  const [todays, setTodays] = useState<{
    town?: Town;
    guesses: Guess[];
  }>({ guesses: [] });

  const addGuess = useCallback(
    (newGuess: Guess) => {
      if (todays == null) {
        return;
      }

      const newGuesses = [...todays.guesses, newGuess];

      setTodays((prev) => ({ town: prev.town, guesses: newGuesses }));
      saveGuesses(dayString, newGuesses);
    },
    [dayString, todays]
  );

  useEffect(() => {
    const guesses = loadAllGuesses()[dayString] ?? [];
    const town = getTown(dayString);

    setTodays({ town, guesses });
  }, [dayString]);

  const randomAngle = useMemo(
    () => seedrandom.alea(dayString)() * 360,
    [dayString]
  );

  const imageScale = useMemo(() => {
    const normalizedAngle = 45 - (randomAngle % 90);
    const radianAngle = (normalizedAngle * Math.PI) / 180;
    return 1 / (Math.cos(radianAngle) * Math.sqrt(2));
  }, [randomAngle]);

  return [todays, addGuess, randomAngle, imageScale];
}

function getTown(dayString: string) {
  /*const currentDayDate = DateTime.fromFormat(dayString, "yyyy-MM-dd");
  let pickingDate = DateTime.fromFormat("2022-03-21", "yyyy-MM-dd");
  let smallTownCooldown = 0;
  let pickedTown: Town | null = null;

  do {
    smallTownCooldown--;

    const pickingDateString = pickingDate.toFormat("yyyy-MM-dd");*/

    const forcedTownCode = forcedTowns[dayString];
    const forcedTown =
    forcedTownCode != null
      ? townsWithImage.find((town) => town.code === forcedTownCode)
      : undefined;

  return (
    forcedTown ??
    townsWithImage[
      Math.floor(seedrandom.alea(dayString)() * townsWithImage.length)
    ]
  );
}